<style scoped>
  .inputTips{display: inline-block;margin-right: 24px;font-size: 14px;color: #657180;text-align: right;vertical-align: top;margin-top: 8px;}
  .basic >>> .ivu-select{width: 440px;}
  .basic >>> .ivu-input{border-radius: 20px;height: 40px;line-height: 38px;padding-left: 25px;font-size: 14px;color: #464c5b;text-align: left;}
  .notice-background{background: url("/img/sys/bg9.png");height: 140px;}
  .logo{width: 140px;height: 140px;border-radius: 70px;background-color: #f6f6f6;display: inline-block;line-height: 140px;margin-top: 50px;}
</style>

<template>
  <div>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <div class="basic" style="background-color: #fff;text-align: center;">
      <div class="logo">
        <img style="width: 86px;height: 42px;vertical-align: middle;" :src="companyName == '刚峰'?'/img/header/GFlogo.png':'/img/header/logo1.png'">
      </div>
      <div style="margin-top: 24px;">
        <p class="inputTips">全称</p>
        <Input v-model="fullName"  style="width: 440px" />
      </div>
      <div style="margin-top: 24px;">
        <p class="inputTips">简称</p>
        <Input v-model="shortName"  style="width: 440px" />
      </div>
      <div style="margin-top: 24px;">
        <p class="inputTips">电话</p>
        <Input v-model="mobile"  style="width: 440px" />
      </div>
      <div style="margin-top: 24px;">
        <p class="inputTips">地址</p>
        <Input v-model="address"  style="width: 440px" />
      </div>
      <Button @click="updateInfo" style="width: 150px;height: 36px;background-color: #00a2e9;border-radius: 18px;color: #fff;margin: 40px 0 80px 0;">保存</Button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "basic",
    data () {
      return {
        fullName : '云联律师事务所互联网管理平台',
        shortName : '云联',
        mobile : '0898-68602072',
        address : '海口市美兰区和平大道20号鹏辉大厦10F',
        itemId:'',
      }
    },
    mounted:function(){
      this.getInfo()
    },
		computed:{
			companyName:function(){
				return companyName
			},
		},
    methods:{
      getInfo:function(){
        var _this = this
        _this.send({
          headers:'T/GroupInfo',
          success:function (res) {
            _this.$store.state.companyName = res.GroupName
            _this.fullName = res.GroupName
            _this.$store.state.companyShortName = res.GroupShortName
            _this.shortName = res.GroupShortName
            _this.mobile = res.GroupContact
            _this.address = res.GroupAddress
            _this.itemId = res.GroupId
          }
        })
      },
      updateInfo:function () {
        var _this = this
        _this.send({
          headers:'T/GroupUpdate',
          data:{
            GroupId:_this.itemId,
            GroupAddress:_this.address,
            GroupContact:_this.mobile,
            GroupShortName:_this.shortName,
            GroupName:_this.fullName,
          },
          success:function (res) {
            _this.getInfo()
            _this.$Notice.success({
              title:'系统消息',
              desc:'修改成功！',
            })
          }
        })
      }
    }
  }
</script>


